import { render } from "./seating_chart_sort_by.vue?vue&type=template&id=3ddf597c"
import script from "./seating_chart_sort_by.vue?vue&type=script&lang=js"
export * from "./seating_chart_sort_by.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__